/**
 * Which product this session belongs to.
 *
 * There is exactly one signal for this in the app: `app_source`, written once
 * by containers/autologin/index.js from the `src` query param. There is no
 * tenant or client field on the user or the plan, so this is it.
 *
 * Existing code reads the raw localStorage key inline in ~24 places, almost all
 * of it cosmetic (which header to render, where to redirect after booking).
 * This helper exists so the newer, behavioural checks have one spelling.
 *
 * CAVEAT worth knowing before adding more callers: the key is sticky. It is
 * only cleared by AuthenticationService.logout() -> StorageService.clearAll()
 * -> localStorage.clear(). Someone who enters via PB and later signs in
 * normally, without logging out, keeps "pb" for the rest of that browser's
 * life. That is tolerable for a header; it is worse for anything that changes
 * a flow. If this starts gating more behaviour, clear it on a normal OTP login
 * the way app/store.js already clears the restricted-session flag.
 */
export function isPBSession() {
  try {
    return localStorage.getItem("app_source") === "pb";
  } catch {
    // Private mode / blocked site data: default to the MLI experience, which
    // is the full one. Never break a screen over this.
    return false;
  }
}
